<span class="c-field-value__text" [ngClass]="data.changed ? '-changed' : ''">
  <gtd-ui-field-default-string-or-empty [data]="data.method"></gtd-ui-field-default-string-or-empty>

  <span
    *ngIf="data.changed"
    class="c-modal__hint"
    p500UITooltip
    i18n-tooltipData="@@finance.payment_method_changed_tooltip"
    tooltipData="Payment Method was changed after Invoice was created"
    >?</span
  >
</span>
